<template>
  <div id="page-user-list">
    <div class="vx-card p-6 minus-top">
      <div class="vx-col md:w-1/2 mt-2 w-full mb-2">
        <span class="title-page">{{$t('button.manageNotificationsAccount')}}</span>
      </div>
        <div class="flex flex-wrap items-center">
          <div class="flex-grow">
          <vs-button
              class="text-size"
              color="primary"
              type="border"
              icon-pack="feather"
              @click="openPopup"
              >
            {{$t('button.addAnAccount')}}
          </vs-button>
          </div>
        </div>
        <ag-grid-vue style="height: 55vh"
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :animateRows="true"
          :pagination="true"
          :paginationPageSize="20"
          :onGridReady="onGridReady"
          :suppressPaginationPanel="true">
        </ag-grid-vue>

        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
          />
    </div>
    <vs-popup :title="$t('warningManager.emailGetNotify')" :active.sync="activePopup">
      <div class="vx-row">
        <div class="vx-col w-full"  v-for="(item) in tagsListAction" >
          <div class="vx-col col-12 w-full mt-1">
            <vue-tags-input style = "margin-top: 0px !important;max-width: 100% !important;"
            v-validate="'max:255'"
            :placeholder="$t('warningManager.importEmail')"
            v-model="item.tag2"
            :tags=item.action
            @tags-changed="newTags => item.action = newTags"
            @before-adding-tag="checkTag"
            allow-edit-tags
            />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
            <vs-button class="border-radius ml-auto mt-2" icon="icon-X" icon-pack="feather" @click="sendRequest" :disabled="!validateForm">{{$t('button.sendRequire')}}
            </vs-button>
            <vs-button class="border-radius ml-4 mt-2" type="border" icon="icon-X" icon-pack="feather" @click="activePopup = false">{{$t('button.closed')}}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: {
      AgGridVue,
      CellRendererActions,
      VueTagsInput
  },
  data(){
      return{
          maxPageNumbers:6,
          gridOptions:{},
          gridApi:null,
          rowData:[],
          defaultColDef:{},
          activePopup: false,
          email:null,
          isUpdate:false,
          columnDefs:[
              {
                  headerName:'Email',
                  field:'email',
                  width:80
              },
              {
                  headerName: this.$t('warningManager.transactions'),
                  field: 'transactions',
                  width: 20,
                  cellRendererFramework: 'CellRendererActions',
              },
          ],
          components: {
              AgGridVue,
              CellRendererActions
          },
          user: {
              gender: null,
              city: null,
              district: null,
              subDistrict: null,
              address: null,
              houseNumber: null,
              password: "",
              rePassword: "",
              activeStatus: 0
          },
          tagsListAction:[{
              action:[]
          }],
          checkNull:null,
          checkEmail: false
      }
  },
  watch:{
    '$store.state.windowWidth'(val) {
      if (val <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }

      if (val > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    '$store.state.reduceButton'() {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      }, 650);
    },
    '$store.state.isUpdateUser'(val) {
      if (val) {
        this.initScreen();
        this.$store.commit('UPDATE_USER_SUCCESS', false);
      }
    },
  },
  computed:{
      validateForm() {
          return !this.errors.any();
      },
      totalPages() {
          if (this.gridApi) return this.gridApi.paginationGetTotalPages();
          else return 0
      },
      currentPage: {
          get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
          },
          set(val) {
          this.gridApi.paginationGoToPage(val - 1)
          }
      }
  },
  methods:{
    openPopup: function(){
      this.activePopup = true;
      this.tagsListAction[0].tag2 = [];
      this.tagsListAction[0].action = [];
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    checkTag(obj) {
      obj.addTag();
    },
    onChangePage: function(){
      this.$oauth.post('/user/user-allow').then((res) => {
        const data = res.data[0].emailAllowNotify.split(',');
        this.rowData = data.map(el => {
          return {
              email: el
          }
        });
      })
    },
    sendRequest: function(){
      let checkValidateEmail = false;
      const result = this.tagsListAction[0].action.map(el =>  el.text);
      if (result.length < 1){
        return this.$vs.notify({
        text:this.$t('warningManager.textEmailEmpty'),
        icon:'icon-alert',
        iconPack:'feather',
        color:'danger'
        })
      }
      else{
        result.forEach(el => {
          if (!this.validateEmail(el)){
            checkValidateEmail = true;
            return this.$vs.notify({
            text:this.$t('warningManager.textEmailInvalidate') + ':' + el,
            icon:'icon-alert',
            iconPack:'feather',
            color:'danger'
            })
          }
        })
      }
      if (checkValidateEmail) return false;
      const data = this.rowData;
      let checkEmail = false;
      result.map(email => {
        data.map(el => {
          if(email.toLowerCase() == el.email.toLowerCase()){
              checkEmail =  true
          }
        })
      })
      if(checkEmail){
        return this.$vs.notify({
          text: this.$t('warningManager.textEmailWasRegistered'),
          icon: 'icon-alert',
          iconPack: 'feather',
          color: 'danger'
        })
      }
      const payloadUser = {
        emailAllowNotify: result.toString()
      }
      this.$oauth.post('/user/update-notify', payloadUser).then(() => {
        this.activePopup = false;
        this.tagsListAction[0].action = [];
        this.initScreen();
        this.$vs.loading.close();
        return this.$vs.notify({
            text: this.$t('warningManager.textSuccessfulNotification'),
            icon: 'icon-alert',
            iconPack: 'feather',
        })
      })
    },
    onGridReady(){
        if(this.$store.state.windowWidth <= 1024){
        this.maxPageNumbers = 5;
        }
        else{
        this.maxPageNumbers = 7;
        }
        if(this.$store.state.windowWidth > 1024){
        this.gridApi.sizeColumnsToFit();
        }
    },
    initScreen(){
        this.onChangePage();
    }
  },
  async created(){
    this.$oauth.get('/user/current').then((response) => {
        this.user = Object.assign({}, this.user, response.data);
    })
    this.initScreen();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
}
</script>
<style scoped>
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.minus-top{
    margin-top: -24px;
}

</style>
